import React from 'react';
import _ from 'lodash';

import { PANEL_LIGHT_BG } from '../../constants/constants';
import { navbarHeight, sidebarWidth } from '../../constants/gridConfig';
import { useOverlay } from '../../contexts/OverlayContext';

const OverlaySider = ({
  side = 'left',
  onlyButton,
  width = sidebarWidth,
  fontSize = 11,
  children,
  zIndex = 15,
}) => {
  const { overlayProps } = useOverlay();
  const collapsed = overlayProps[side].collapsed

  return (
    <div
      id={`overlay-sider-${side}`}
      style={{
        position: 'fixed',
        top: 0,
        [`${side}`]: 0,
        [`margin${_.capitalize(side)}`]: collapsed ? - width : 0,
        minHeight: onlyButton ? undefined : `calc(100vh - ${navbarHeight}px)`,
        // bottom + overflow : le scroll réel est déjà géré un niveau plus bas
        // (.menu_wrapper / .left-side__summary, hauteur explicite + leur
        // propre overflow). Sans plafond ici, le moindre débordement de
        // quelques px dans le contenu agrandissait ce panneau `fixed` au-delà
        // du viewport, ce qui faisait apparaître la scrollbar du document
        // entier (perte de largeur sur toute la page) au lieu de rester
        // contenu dans le panel.
        bottom: onlyButton ? undefined : 0,
        overflow: onlyButton ? undefined : 'hidden',
        marginTop: navbarHeight,
        backgroundColor: PANEL_LIGHT_BG,
        // Taille de police du panel : hérite en cascade, seuls les éléments à
        // taille explicite (icônes, titres de section) y échappent.
        fontSize,
        // Fine bordure bleu marine (couleur navbar) pour séparer le panel du
        // document : côté document uniquement (bord droit du panel gauche, bord
        // gauche du panel droit). Atténuée (rgba) pour rester légère à l'œil.
        [side === 'left' ? 'borderRight' : 'borderLeft']: '1px solid rgba(11, 34, 57, 0.25)',
        transition: 'margin 0.3s',
        zIndex,
        width,
      }}
    >
      {children}
    </div>
  );
};

export default React.memo(OverlaySider);
